import { Button } from "@components/ui/base/button"

export const CREATE_PRODUCT_CONFIRM_VIEW = (params: any) => {
  const { submitEl, uploadStep, setModalView } = params
  const handleClick = () => {
    submitEl.current.click()
    if (uploadStep == 0) {
      setModalView({ name: "" })
    }
  }
  return (
    <>
      <div className="sl-pb-6 sl-text-center">
        <h1 className="sl-fonts">Ready to create product</h1>
        <p className="sl-pt-8">
          Make sure the information added is correct, you won&apos;t be able to
          change all details later.
        </p>
      </div>

      <div className="sl-text-center">
        <Button onClick={() => handleClick()}>Go ahead!</Button>
      </div>
      <div className="sl-flex sl-justify-center sl-pt-8">
        <p
          className="sl-font-medium sl-text-red-500 sl-cursor-pointer hover:sl-underline"
          onClick={() => setModalView({ name: "" })}
        >
          Go back
        </p>
      </div>
    </>
  )
}

export default CREATE_PRODUCT_CONFIRM_VIEW
